export default __webpack_public_path__ + "2cd732ba8deac460a00f71626213699c.svg";